
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { 
  LayoutDashboard,
  Users,
  Building2,
  Calendar,
  FileText,
  Settings,
  LogOut,
  CreditCard,
  Shield,
  BarChart,
  MessageSquare,
  Globe,
  Bell,
  Home,
  Share2
} from "lucide-react";

export const AdminSidebar = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      toast({
        title: "Signed out successfully",
        description: "You have been logged out",
      });
      navigate("/");
    } catch (error) {
      console.error("Error signing out:", error);
      toast({
        title: "Error",
        description: "There was a problem signing out",
        variant: "destructive",
      });
    }
  };

  const menuItems = [
    {
      icon: Home,
      label: "Home",
      onClick: () => navigate("/"),
    },
    {
      icon: LayoutDashboard,
      label: "Dashboard",
      onClick: () => navigate("/admin"),
    },
    {
      icon: Users,
      label: "Users",
      onClick: () => navigate("/admin/users"),
    },
    {
      icon: Building2,
      label: "Properties",
      onClick: () => navigate("/admin/properties"),
    },
    {
      icon: Calendar,
      label: "Bookings",
      onClick: () => navigate("/admin/bookings"),
    },
    {
      icon: CreditCard,
      label: "Payments",
      onClick: () => navigate("/admin/payments"),
    },
    {
      icon: Shield,
      label: "Security",
      onClick: () => navigate("/admin/security"),
    },
    {
      icon: BarChart,
      label: "Analytics",
      onClick: () => navigate("/admin/analytics"),
    },
    {
      icon: MessageSquare,
      label: "Messages",
      onClick: () => navigate("/admin/messages"),
    },
    {
      icon: Globe,
      label: "Content",
      onClick: () => navigate("/admin/content"),
    },
    {
      icon: Share2,
      label: "Social Media",
      onClick: () => navigate("/admin/social-media"),
    },
    {
      icon: Bell,
      label: "Notifications",
      onClick: () => navigate("/admin/notifications"),
    },
    {
      icon: FileText,
      label: "Reports",
      onClick: () => navigate("/admin/reports"),
    },
    {
      icon: Settings,
      label: "Settings",
      onClick: () => navigate("/admin/settings"),
    },
  ];

  return (
    <div className="w-64 h-screen bg-white border-r p-4 flex flex-col">
      <div className="flex-1 space-y-2">
        {menuItems.map((item) => (
          <Button
            key={item.label}
            variant="ghost"
            className="w-full justify-start"
            onClick={item.onClick}
          >
            <item.icon className="h-4 w-4" />
            <span className="ml-2">{item.label}</span>
          </Button>
        ))}
      </div>
      
      <Button
        variant="ghost"
        className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-100"
        onClick={handleLogout}
      >
        <LogOut className="h-4 w-4" />
        <span className="ml-2">Sign Out</span>
      </Button>
    </div>
  );
};
